module.exports = __webpack_public_path__ + "static/media/sheep-eating-rayo.52a81667.png";